// Common parser function
const safeParseObject = (raw, validate) => {
    if (!raw) {
        return {};
    }
    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
            return {};
        }
        return validate(parsed) ? parsed : {};
    } catch {
        return {};
    }
};

// Safely parse chat threads from localStorage, ensuring the structure is correct
const safeParseThreads = raw =>
    safeParseObject(raw, obj => {
        for (const key in obj) {
            if (!Array.isArray(obj[key])) {
                return false;
            }
        }
        return true;
    });

// Append a new message to the appropriate thread for a given userId, ensuring the threads structure is maintained
const appendToThread = (prev, userId, msg) => {
    const id = String(userId ?? '');
    if (!id || id === 'undefined' || id === 'null') {
        return prev && typeof prev === 'object' && !Array.isArray(prev) ? prev : {};
    }

    const base = prev && typeof prev === 'object' && !Array.isArray(prev) ? prev : {};
    const current = Array.isArray(base[id]) ? base[id] : [];
    return { ...base, [id]: [...current, msg] };
};

// Autocomplete for agents
const pickUserFromAutocomplete = ({ val, setChats, setSelectedUserId, setIsAutocompleteOpen }) => {
    if (!val || !val.id) {
        return;
    }
    const pickedId = String(val.id);
    const pickedName = val?.name?.replace(/\s*\([^)]*\)\s*$/, '') || pickedId;

    if (!pickedId) {
        return;
    }

    setChats(prev => {
        if (prev.find(c => c.id === pickedId)) {
            return prev;
        }

        return [...prev, { id: pickedId, name: pickedName }];
    });

    setSelectedUserId(pickedId);
    setIsAutocompleteOpen(false);
};

export { safeParseThreads, appendToThread, pickUserFromAutocomplete };
